<template lang="pug">
  div(name="chartCluster")
    div
      .cluster-container(v-bind:id="containerID")
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
// import am4themesspiritedaway from '@amcharts/amcharts4/themes/spiritedaway'
import am4themesanimated from '@amcharts/amcharts4/themes/animated'

// am4core.useTheme(am4themesspiritedaway)
am4core.useTheme(am4themesanimated)

export default {
  props: {
    clusterdata: Array
  },
  data () {
    return {
      name: 'chartCluster',
      chart: {},
      containerID: this.getChartId()
    }
  },
  computed: {
    cd: function () {
      return this.clusterdata
    }
  },
  mounted () {
    this.chart = am4core.create(this.containerID, am4charts.XYChart)
    this.chart.hiddenState.properties.opacity = 0 // this creates initial fade-in

    this.chart.data = this.cd
    // Create axes
    var categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis())
    categoryAxis.dataFields.category = 'name'
    categoryAxis.renderer.grid.template.strokeOpacity = 0
    categoryAxis.renderer.minGridDistance = 5
    categoryAxis.renderer.labels.template.dx = -40
    categoryAxis.renderer.minWidth = 120
    categoryAxis.renderer.tooltip.dx = -40
    categoryAxis.renderer.labels.template.truncate = true
    categoryAxis.renderer.labels.template.maxWidth = 105
    categoryAxis.renderer.labels.template.tooltipText = '{category}'

    var valueAxis = this.chart.xAxes.push(new am4charts.ValueAxis())
    valueAxis.renderer.inside = true
    valueAxis.renderer.labels.template.fillOpacity = 0.3
    valueAxis.renderer.grid.template.strokeOpacity = 0
    valueAxis.min = 0
    valueAxis.cursorTooltipEnabled = false
    valueAxis.renderer.baseGrid.strokeOpacity = 0
    valueAxis.renderer.labels.template.dy = 20
    valueAxis.title.paddingTop = 20
    valueAxis.title.text = 'Часы'

    var series = this.chart.series.push(new am4charts.ColumnSeries())
    series.dataFields.valueX = 'hours'
    series.dataFields.categoryY = 'name'
    series.tooltipText = '{valueX.value}'
    series.tooltip.pointerOrientation = 'vertical'
    series.tooltip.dy = -30
    series.columnsContainer.zIndex = 100

    var columnTemplate = series.columns.template
    columnTemplate.height = am4core.percent(50)
    columnTemplate.maxHeight = 30
    // columnTemplate.column.cornerRadius(60, 10, 60, 10)
    columnTemplate.strokeOpacity = 0

    series.heatRules.push({ target: columnTemplate, property: 'fill', dataField: 'valueX', min: am4core.color('#e5dc36'), max: am4core.color('#5faa46') })
    series.mainContainer.mask = undefined

    var cursor = new am4charts.XYCursor()
    this.chart.cursor = cursor
    cursor.lineX.disabled = true
    cursor.lineY.disabled = true
    cursor.behavior = 'none'
  },
  methods: {
    getChartId () {
      var chartId = Math.random() * 1000
      return 'chartContainer' + Math.round(chartId)
    }
  },
  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
  }
}
</script>

<style scoped>
  body {
    height:97vh;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  }
  .cluster-container {
    width: 100%;
    height: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/chartCluster.vue